"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionEdit = exports.DistributionEditPure = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
exports.getFirstItemId = getFirstItemId;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var DeliveryMethodsActions = require("@caddigital/sok-reducers/lib/actions/distribution/deliveryMethods");
var DistributionListActions = require("@caddigital/sok-reducers/lib/actions/distribution/list");
var NewExternalUserActions = require("@caddigital/sok-reducers/lib/actions/distribution/newExternalUser");
var FinishingsActions = require("@caddigital/sok-reducers/lib/actions/distribution/finishings");
var AddressBookActions = require("@caddigital/sok-reducers/lib/actions/distribution/addressBook");
var PrintProvidersActions = require("@caddigital/sok-reducers/lib/actions/distribution/printProviders");
var RecipientsActions = require("@caddigital/sok-reducers/lib/actions/distribution/recipients");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/distribution/wizard");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Types = require("types");
var HeaderComponents_1 = require("./HeaderComponents");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var step1_1 = require("./steps/step1");
var step2_1 = require("./steps/step2");
require("./style.scss");
var GenericConfirmDialog_1 = require("components/GenericConfirmDialog");
var mapStateToProps = function (state) {
    return {
        wizard: state.distribution.wizard,
        deliveryMethods: state.distribution.deliveryMethods,
        finishings: state.distribution.finishings,
        printProviders: state.distribution.printProviders,
        addressBook: state.distribution.addressBook,
        recipients: state.distribution.recipients,
        newExternalUser: state.distribution.newExternalUser,
        cart: state.cart.data,
        user: state.auth.current.user,
        regions: state.user.region.list,
        author: state.distribution.wizard.author
    };
};
exports.mapStateToProps = mapStateToProps;
function getFirstItemId(list) {
    if (list.length > 0 && list[0]) {
        return list[0].id;
    }
    return -1;
}
var mapDispatchToProps = function (dispatch) { return ({
    toggleWizard: function () { return dispatch(WizardActions.closeMenu()); },
    changeName: function (_a) {
        var value = _a.target.value;
        return dispatch(WizardActions.changeName(value));
    },
    changeDescription: function (_a) {
        var value = _a.target.value;
        return dispatch(WizardActions.changeDescription(value));
    },
    changeStep: function (props) { return function (step) {
        return dispatch(WizardActions.changeStep(step));
    }; },
    backToList: function (props) {
        return function () { return (dispatch(WizardActions.changeStep2Display('LIST')),
            dispatch(RecipientsActions.unselect(props.recipients.selected)),
            dispatch(AddressBookActions.unselect(props.addressBook.selected))); };
    },
    deleteDistribution: function (props) { return function () {
        dispatch(DistributionListActions.deleteDistributionsRequest([props.wizard.id]));
        dispatch(WizardActions.closeMenu());
    }; },
    saveDistribution: function (props) { return function () {
        dispatch(WizardActions.editDistributionRequest(props.wizard.id, props.currentProject.uuid, props.wizard.step1.name, props.wizard.step1.description, Object.values(props.wizard.distributionRecipients)));
    }; },
    changeStep2View: function (state) { return function () { return (dispatch(WizardActions.changeStep2Display(state)),
        dispatch(NewExternalUserActions.actions.clearState())); }; },
    changeStep2Tab: function (tab) { return dispatch(WizardActions.changeStep2Tab(tab)); },
    changeStep2AddNewDeliveryAddress: function (status) { return function () {
        return dispatch(WizardActions.changeStep2AddNewDeliveryAddress(status));
    }; },
    fetchExternalUsers: function (folder) { return function () {
        return dispatch(AddressBookActions.fetchRequest(folder));
    }; },
    fetchRecipients: function (project) { return function () {
        return dispatch(RecipientsActions.fetchRequest(project));
    }; },
    searchRecipients: function (project) { return function (e) {
        return dispatch(RecipientsActions.fetchRequest(project));
    }; },
    searchExternalUsers: function (folder) { return function (e) {
        return dispatch(AddressBookActions.fetchRequest(folder));
    }; },
    selectRecipientsList: function (ids) { return function () {
        return dispatch(RecipientsActions.select(ids));
    }; },
    unselectRecipientsList: function (ids) { return function () {
        return dispatch(RecipientsActions.unselect(ids));
    }; },
    selectAddressBookList: function (ids) { return function () {
        return dispatch(AddressBookActions.select(ids));
    }; },
    unselectAddressBookList: function (ids) { return function () {
        return dispatch(AddressBookActions.unselect(ids));
    }; },
    changeAddNewRecipientField: function (field) {
        return function (_a) {
            var value = _a.target.value;
            return dispatch(NewExternalUserActions.actions.updateField(field, value));
        };
    },
    clearAddNewRecipient: function () { return (dispatch(NewExternalUserActions.actions.clearState()),
        dispatch(WizardActions.changeStep2AddNewDeliveryAddress(false))); },
    cancel: function (project) {
        dispatch(AddressBookActions.clearState()),
            dispatch(RecipientsActions.clearState()),
            dispatch(WizardActions.clearWizard()),
            dispatch(DistributionListActions.fetchDistributionListRequest(project));
    },
    createNewExternalUser: function (folder, newRecipient) { return function () {
        return dispatch(NewExternalUserActions.actions.createRequest(folder, newRecipient));
    }; },
    addDistributionRecipient: function (recipients, selected) {
        return function () {
            return (dispatch(WizardActions.addDistributionRecipient(recipients)),
                dispatch(WizardActions.changeStep2Display('LIST')),
                dispatch(RecipientsActions.unselect(selected)),
                dispatch(AddressBookActions.unselect(selected)));
        };
    },
    removeDistributionRecipient: function (uuid) { return function () {
        return dispatch(WizardActions.removeDistributionRecipient(uuid));
    }; },
    fetchDistributionInformations: function () { return (dispatch(DeliveryMethodsActions.Actions.fetchRequest()),
        dispatch(FinishingsActions.Actions.fetchRequest()),
        dispatch(PrintProvidersActions.Actions.fetchRequest())); },
    changeDistributionRecipientQuantity: function (uuid) {
        return function (_a) {
            var value = _a.value;
            return dispatch(WizardActions.changeDistributionRecipientQuantity(uuid, value));
        };
    },
    changeDistributionRecipientFinishing: function (uuid) {
        return function (_a) {
            var id = _a.id;
            return dispatch(WizardActions.changeDistributionRecipientFinishing(uuid, id));
        };
    },
    changeDistributionRecipientDeliveryMethod: function (uuid) {
        return function (_a) {
            var id = _a.id;
            return dispatch(WizardActions.changeDistributionRecipientDeliveryMethod(uuid, id));
        };
    },
    changeDistributionRecipientPrintProvider: function (uuid) {
        return function (_a) {
            var id = _a.id;
            return dispatch(WizardActions.changeDistributionRecipientPrintProvider(uuid, id));
        };
    },
    sendErrorToast: function () {
        return dispatch(toastActions.addNewToast((0, translation_1.getLocalization)('distributionWizard/toast/header'), (0, translation_1.getLocalization)('distributionWizard/toast/content'), 'FAILURE'));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var getStep = function (props, isAdminOrAuthor) { return ({
    0: React.createElement(step1_1.default, __assign({}, props, { isAdminOrAuthor: isAdminOrAuthor })),
    1: React.createElement(step2_1.default, __assign({}, props, { isAdminOrAuthor: isAdminOrAuthor }))
}); };
var DistributionEditPure = function (props) {
    var perm = props.currentProject && props.currentProject.perm
        ? props.currentProject.perm & ~acl.FEATURE_MASK
        : 0x00;
    var isAdminOrAuthor = (props.currentProject && !!(perm & acl.PROJECT_ADMIN_GRANT)) ||
        props.user
            .map(function (u) {
            return u.level === 'SuperAdminUserGroup' ||
                (props.author && u.uuid === props.author.uuid) ||
                false;
        })
            .getOrElse(false);
    function tryCancelOrOpenConfirmDialog() {
        if (!props.wizard.modified) {
            return props.cancel(props.currentProject);
        }
        props.setIsDiscardChangesDialogOpen(true);
    }
    return (React.createElement(sok_ui_1.Overlay, { isOpen: props.wizard.isOpen === 'EDIT', onClose: tryCancelOrOpenConfirmDialog },
        React.createElement(sok_ui_1.SideMenu, { className: 'sok-distribution-edit', isOpen: props.wizard.isOpen === 'EDIT', docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: tryCancelOrOpenConfirmDialog }, props.wizard.name),
            React.createElement(sok_ui_1.Container, null,
                React.createElement(sok_ui_1.StepBar, { currentStep: props.wizard.wizardStep, steps: ['1', '2'], showStepText: false, onChange: function (step) { return props.changeStep(props)(step); } }),
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.wizard.isSaving, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/edit/saving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/edit/saved')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/edit/error'))),
                getStep(props, isAdminOrAuthor)[props.wizard.wizardStep]),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(HeaderComponents_1.HeaderComponents, __assign({ key: "content" }, props, { cancel: tryCancelOrOpenConfirmDialog, disableFields: isAdminOrAuthor })))),
        React.createElement(GenericConfirmDialog_1.GenericConfirmDialog, { firstRow: (0, translation_1.getLocalization)('userfront/orderWizard/unsavedChanges'), secondRow: (0, translation_1.getLocalization)('userfront/orderWizard/areYouSure'), isOpen: props.isDiscardChangesDialogOpen, setIsOpen: props.setIsDiscardChangesDialogOpen, confirm: function () {
                props.setIsDiscardChangesDialogOpen(false);
                props.cancel(props.currentProject);
            } })));
};
exports.DistributionEditPure = DistributionEditPure;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isDiscardChangesDialogOpen', 'setIsDiscardChangesDialogOpen', false), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.wizard.isOpen !== 'CREATE' ||
            nextProps.wizard.errors !== this.props.wizard.errors) {
            return true;
        }
        return false;
    },
    componentDidMount: function () {
        this.props.fetchDistributionInformations();
        this.props.fetchExternalUsers(this.props.currentFolder)();
        this.props.fetchRecipients(this.props.currentProject)();
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.wizard.isOpen !== prevProps.wizard.isOpen &&
            this.props.wizard.isOpen === 'EDIT') {
            this.props.fetchDistributionInformations();
            this.props.fetchExternalUsers(this.props.currentFolder)();
            this.props.fetchRecipients(this.props.currentProject)();
        }
        if (prevProps.currentProject !== this.props.currentProject) {
            this.props.fetchExternalUsers(this.props.currentFolder)();
            this.props.fetchRecipients(this.props.currentProject)();
        }
    }
}), recompose_1.pure);
exports.DistributionEdit = enhance(exports.DistributionEditPure);
